(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-v4-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.__cc4r) return; root.__cc4r=true;
    var rail=root.querySelector('[data-rail]'), thumb=root.querySelector('[data-thumb]'), pos=root.querySelector('[data-pos]'), btns=root.querySelectorAll('.cc4r-arrow');
    if(!rail) return;
    function step(){ var c=rail.querySelector('.cc4r-card'); if(!c) return rail.clientWidth; var cs=getComputedStyle(rail), g=parseFloat(cs.columnGap)||0, w=c.getBoundingClientRect().width+g; var n=Math.max(1,Math.floor((rail.clientWidth-(parseFloat(cs.paddingLeft)||0))/w)); return n*w; }
    function update(){ var max=rail.scrollWidth-rail.clientWidth, x=rail.scrollLeft;
      if(btns.length===2){ btns[0].disabled=x<=2; btns[1].disabled=x>=max-2; }
      if(thumb){ var f=Math.min(1,rail.clientWidth/rail.scrollWidth); thumb.style.width=(f*100)+'%'; thumb.style.transform='translateX('+(max>0?(x/max)*((1/f)-1)*100:0)+'%)'; }
      if(pos){ var cards=rail.querySelectorAll('.cc4r-card'), n=cards.length; if(n){ var cs=getComputedStyle(rail), g=parseFloat(cs.columnGap)||0, cw=cards[0].getBoundingClientRect().width+g;
        var vis=Math.max(1,Math.floor((rail.clientWidth-(parseFloat(cs.paddingLeft)||0)+g+1)/cw)); var a=Math.min(n,Math.round(x/cw)+1); if(x>=max-2) a=Math.max(1,n-vis+1); var z=Math.min(n,a+vis-1);
        pos.textContent=(vis>1?a+'-'+z:a)+' of '+n; } } }
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    btns.forEach(function(b){ b.addEventListener('click',function(){ rail.scrollBy({left:step()*(+b.dataset.dir),behavior:reduce?'auto':'smooth'}); }); });
    rail.addEventListener('scroll',function(){ window.requestAnimationFrame(update); },{passive:true});
    window.addEventListener('resize',update); update();
    var cards=root.querySelectorAll('.cc4r-card');
    function clampCheck(){ cards.forEach(function(c){ var p=c.querySelector('.cc4r-quote p'), m=c.querySelector('.cc4r-more'); if(!p||!m) return; if(c.classList.contains('is-open')){ m.hidden=false; return; } c.classList.remove('is-clamped'); var over=p.scrollHeight>p.clientHeight+2; c.classList.toggle('is-clamped',over); m.hidden=!over; }); }
    cards.forEach(function(c){ var m=c.querySelector('.cc4r-more'); if(!m) return; m.addEventListener('click',function(){ var o=c.classList.toggle('is-open'); m.setAttribute('aria-expanded',o?'true':'false'); m.textContent=o?'Show less':'Read more'; clampCheck(); update(); }); });
    window.addEventListener('resize',clampCheck); clampCheck(); if(document.fonts&&document.fonts.ready) document.fonts.ready.then(clampCheck);
  }
  function all(){ document.querySelectorAll('[data-cc4r]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',all); else all();
  document.addEventListener('shopify:section:load',function(e){ var r=e.target.querySelector('[data-cc4r]'); if(r) init(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leif-v4-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.__lv4r) return; root.__lv4r=true;
    var rail=root.querySelector('[data-rail]'), thumb=root.querySelector('[data-thumb]'), pos=root.querySelector('[data-pos]'), btns=root.querySelectorAll('.lv4r-arrow');
    if(!rail) return;
    function step(){ var c=rail.querySelector('.lv4r-card'); if(!c) return rail.clientWidth; var cs=getComputedStyle(rail), g=parseFloat(cs.columnGap)||0, w=c.getBoundingClientRect().width+g; var n=Math.max(1,Math.floor((rail.clientWidth-(parseFloat(cs.paddingLeft)||0))/w)); return n*w; }
    function update(){ var max=rail.scrollWidth-rail.clientWidth, x=rail.scrollLeft;
      if(btns.length===2){ btns[0].disabled=x<=2; btns[1].disabled=x>=max-2; }
      if(thumb){ var f=Math.min(1,rail.clientWidth/rail.scrollWidth); thumb.style.width=(f*100)+'%'; thumb.style.transform='translateX('+(max>0?(x/max)*((1/f)-1)*100:0)+'%)'; }
      if(pos){ var cards=rail.querySelectorAll('.lv4r-card'), n=cards.length; if(n){ var cs=getComputedStyle(rail), g=parseFloat(cs.columnGap)||0, cw=cards[0].getBoundingClientRect().width+g;
        var vis=Math.max(1,Math.floor((rail.clientWidth-(parseFloat(cs.paddingLeft)||0)+g+1)/cw)); var a=Math.min(n,Math.round(x/cw)+1); if(x>=max-2) a=Math.max(1,n-vis+1); var z=Math.min(n,a+vis-1);
        pos.textContent=(vis>1?a+'-'+z:a)+' of '+n; } } }
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    btns.forEach(function(b){ b.addEventListener('click',function(){ rail.scrollBy({left:step()*(+b.dataset.dir),behavior:reduce?'auto':'smooth'}); }); });
    rail.addEventListener('scroll',function(){ window.requestAnimationFrame(update); },{passive:true});
    window.addEventListener('resize',update); update();
    var cards=root.querySelectorAll('.lv4r-card');
    function clampCheck(){ cards.forEach(function(c){ var p=c.querySelector('.lv4r-quote p'), m=c.querySelector('.lv4r-more'); if(!p||!m) return; if(c.classList.contains('is-open')){ m.hidden=false; return; } c.classList.remove('is-clamped'); var over=p.scrollHeight>p.clientHeight+2; c.classList.toggle('is-clamped',over); m.hidden=!over; }); }
    cards.forEach(function(c){ var m=c.querySelector('.lv4r-more'); if(!m) return; m.addEventListener('click',function(){ var o=c.classList.toggle('is-open'); m.setAttribute('aria-expanded',o?'true':'false'); m.textContent=o?'Show less':'Read more'; clampCheck(); update(); }); });
    window.addEventListener('resize',clampCheck); clampCheck(); if(document.fonts&&document.fonts.ready) document.fonts.ready.then(clampCheck);
  }
  function all(){ document.querySelectorAll('[data-lv4r]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',all); else all();
  document.addEventListener('shopify:section:load',function(e){ var r=e.target.querySelector('[data-lv4r]'); if(r) init(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-tp-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.__mbr) return; root.__mbr=true;
    var rail=root.querySelector('[data-mbr-rail]'), thumb=root.querySelector('[data-mbr-thumb]'), pos=root.querySelector('[data-mbr-pos]'), btns=root.querySelectorAll('.mbr-arrow');
    if(!rail) return;
    function step(){ var c=rail.querySelector('.mbr-card'); if(!c) return rail.clientWidth; var cs=getComputedStyle(rail), g=parseFloat(cs.columnGap)||0, w=c.getBoundingClientRect().width+g; var n=Math.max(1,Math.floor((rail.clientWidth-(parseFloat(cs.paddingLeft)||0))/w)); return n*w; }
    function update(){ var max=rail.scrollWidth-rail.clientWidth, x=rail.scrollLeft;
      if(btns.length===2){ btns[0].disabled=x<=2; btns[1].disabled=x>=max-2; }
      if(thumb){ var f=Math.min(1,rail.clientWidth/rail.scrollWidth); thumb.style.width=(f*100)+'%'; thumb.style.transform='translateX('+(max>0?(x/max)*((1/f)-1)*100:0)+'%)'; }
      if(pos){ var cards=rail.querySelectorAll('.mbr-card'), n=cards.length; if(n){ var cs=getComputedStyle(rail), g=parseFloat(cs.columnGap)||0, cw=cards[0].getBoundingClientRect().width+g;
        var vis=Math.max(1,Math.floor((rail.clientWidth-(parseFloat(cs.paddingLeft)||0)+g+1)/cw)); var a=Math.min(n,Math.round(x/cw)+1); if(x>=max-2) a=Math.max(1,n-vis+1); var z=Math.min(n,a+vis-1);
        pos.textContent=(vis>1?a+'-'+z:a)+' of '+n; } } }
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    btns.forEach(function(b){ b.addEventListener('click',function(){ rail.scrollBy({left:step()*(+b.dataset.dir),behavior:reduce?'auto':'smooth'}); }); });
    rail.addEventListener('scroll',function(){ window.requestAnimationFrame(update); },{passive:true});
    window.addEventListener('resize',update); update();
    var cards=root.querySelectorAll('.mbr-card');
    function clampCheck(){ cards.forEach(function(c){ var p=c.querySelector('.mbr-quote p'), m=c.querySelector('.mbr-more'); if(!p||!m) return; if(c.classList.contains('is-open')){ m.hidden=false; return; } c.classList.remove('is-clamped'); var over=p.scrollHeight>p.clientHeight+2; c.classList.toggle('is-clamped',over); m.hidden=!over; }); }
    cards.forEach(function(c){ var m=c.querySelector('.mbr-more'); if(!m) return; m.addEventListener('click',function(){ var o=c.classList.toggle('is-open'); m.setAttribute('aria-expanded',o?'true':'false'); m.textContent=o?'Show less':'Read more'; clampCheck(); update(); }); });
    window.addEventListener('resize',clampCheck); clampCheck(); if(document.fonts&&document.fonts.ready) document.fonts.ready.then(clampCheck);
  }
  function all(){ document.querySelectorAll('[data-mbr]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',all); else all();
  document.addEventListener('shopify:section:load',function(e){ var r=e.target.querySelector('[data-mbr]'); if(r) init(r); });
})();

  } catch(e) { console.error(e); }
})();
})();
